export default __webpack_public_path__ + "static/harmonious-carousel-panel1-2edbbb4d523e859c74732775fb4440a4a3c89fa6e690020d4e2d7c6196871010.png";